import * as React from 'react';

interface OrderErrorsProps {
  orders: Array<Orders>;
}

interface Orders {
    status: string;
    navOrder: {
      Name: string;
      CustomerId: string;
      ShipAddr1: string;
      ShipCity: string;
      ShipZip: string;
    };
}

const OrderErrors = (props: OrderErrorsProps) => {
  if (!props.orders || !props.orders.length) {
    return null;
  }
  return (
    <div className="table table--customer">
      <div className="row row--header">
        <div className="cell">Asiakkaan nimi</div>
        <div className="cell">Osoite</div>
        <div className="cell">Postinumero</div>
        <div className="cell">Kaupunki</div>
      </div>
      {props.orders.map((order, index) => {
        let classes = 'row row--content';
        if (order.status === 'error') {
          classes += ' row--error';
        } else {
          classes += ' row--success';
        }

        return (
          <div className={classes} key={index}>
            <div className="cell">{order.navOrder.Name}</div>
            <div className="cell">{order.navOrder.ShipAddr1}</div>
            <div className="cell">{order.navOrder.ShipZip}</div>
            <div className="cell">{order.navOrder.ShipCity}</div>
          </div>
        );
      })}
    </div>
  );
};

export default OrderErrors;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/OrderErrors.tsx